var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 38,
    viewBox: "0 0 22 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9999 37.6667C18.3811 37.6666 17.7877 37.4206 17.3502 36.983L1.01691 20.6497C0.579477 20.2121 0.33374 19.6187 0.33374 19C0.33374 18.3813 0.579477 17.7879 1.01691 17.3504L17.3502 1.01703C17.5655 0.79417 17.823 0.616411 18.1076 0.494124C18.3923 0.371836 18.6985 0.307468 19.0083 0.304776C19.3181 0.302083 19.6254 0.36112 19.9121 0.478442C20.1989 0.595764 20.4594 0.769022 20.6785 0.988105C20.8976 1.20719 21.0708 1.46771 21.1882 1.75447C21.3055 2.04123 21.3645 2.34848 21.3618 2.6583C21.3591 2.96811 21.2948 3.27429 21.1725 3.55897C21.0502 3.84365 20.8724 4.10112 20.6496 4.31636L5.96591 19L20.6496 33.6837C20.9758 34.01 21.1979 34.4257 21.2879 34.8783C21.3779 35.3308 21.3317 35.7999 21.1552 36.2262C20.9786 36.6525 20.6796 37.0169 20.296 37.2733C19.9124 37.5297 19.4613 37.6666 18.9999 37.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.60157c656ffbbd605f0d4132ca2ee7f8.svg";
export { ForwardRef as ReactComponent };